import React from 'react'

import type { AgentChatMessage } from '~/api/agentChat'

import { MarkdownRenderer } from './MarkdownComponents'
import { MessageBubble } from './MessageBubble'

import styles from './ChatMessage.module.scss'

interface AgentMessageBubbleProps {
  message: AgentChatMessage
}

export const AgentMessageBubble: React.FC<AgentMessageBubbleProps> = ({
  message,
}) => (
  <MessageBubble sender="agent">
    {message.isLoading ? (
      <div className={styles.loadingMessage}>
        <div className={styles.dots}>
          <div className={styles.dot} />
          <div className={styles.dot} />
          <div className={styles.dot} />
        </div>
      </div>
    ) : (
      <>
        <MarkdownRenderer content={message.content} />
        <div className={styles.messageTimestamp}>{message.timestamp}</div>
      </>
    )}
  </MessageBubble>
)

export default AgentMessageBubble
